export default __webpack_public_path__ + "static/media/tete13.1e740bdd.png";